import { gql } from '@apollo/client'

export const GET_AIRBYTE_TOKEN = gql`
  query GET_AIRBYTE_TOKEN {
    getAirbyteToken {
      ... on AirbyteToken {
        token
      }
      ... on StatusMessage {
        message
        title
        code
        success
      }
    }
  }
`
